import React from 'react';
import { Divider, Stack } from '@moda/om';
import { RefreshedMobileSiteNavMenuLinkItem } from '../RefreshedMobileSiteNavMenuLinkItem';
import { RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems } from '../../../../generated/types/RefreshedMobileSiteNavMenuQuery';

interface Props {
  data: RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_mainCategories_mainCategoryItems_subItems;
  onClose: () => void;
}

export const RefreshedMobileNavMainCategoryItem: React.FC<Props> = ({
  data: { label, listLinks },
  onClose
}) => {
  if (!listLinks.length) return null;

  return (
    <Stack className="RefreshedMobileNavMainCategoryItem" space={3}>
      <Divider text={label} treatment="body1" />

      {listLinks.map((link, index) => (
        <RefreshedMobileSiteNavMenuLinkItem
          key={index}
          url={link.url}
          label={link.label}
          isHighlighter={link.isHighlighter}
          onClick={onClose}
        />
      ))}
    </Stack>
  );
};
